export const builder = {
  // Physics prompt dialog
  "builder.physics.title.adjust.flight.time": "Adjust Flight Time",
  "builder.physics.title.adjust.height": "Adjust Height",
  "builder.physics.title.fix": "Fix Pass Flight",
  "builder.physics.button.adjust.time": "Adjust Time",
  "builder.physics.button.adjust.height": "Adjust Height",
  "builder.physics.button.fix": "Fix",
  "builder.physics.height.changed.description":
    "Changing height to {{ height }} ({{ meters }}m) requires a flight time of {{ requiredTime }}s. The current flight time is {{ currentTime }}s.",
  "builder.physics.height.changed.note":
    "The ball arrival time will be adjusted to match the new height.",
  "builder.physics.time.changed.description":
    "The current flight time of {{ currentTime }}s requires a height of {{ height }} ({{ meters }}m).",
  "builder.physics.time.changed.note":
    "The height will be adjusted from {{ fromHeight }} to {{ toHeight }}.",
  "builder.physics.fix.description":
    "This pass flight is invalid. The height of {{ height }} ({{ meters }}m) requires a flight time of {{ requiredTime }}s (current is {{ currentTime }}s.)",
  "builder.physics.fix.option.time":
    "Adjust Time: Set flight time from {{ currentTime }}s to {{ time }}s (keeping height at {{ height }}).",
  "builder.physics.fix.option.height":
    "Adjust Height: Set height from {{ currentHeight }} ({{ currentMeters }}m) to {{ height }} ({{ meters }}m) (keeping current flight time).",

  // Warning list
  "builder.warnings.title": "Warnings",
  "builder.physics.warning.message":
    "{{ name }}'s pass at {{ time }}s: height {{ height }} requires {{ requiredTime }}s flight, actual is {{ actualTime }}s",
  "builder.warning.player.speed":
    "{{ name }} (team {{ team }}) exceeds speed limit by {{ excess }}m/s at {{ time }}s",
  "builder.warning.pass.speed":
    "Pass from {{ kicker }} to {{ receiver }} travels at {{ speed }} m/s at {{ time }}s",
  "builder.warning.kick.speed":
    "Kick from {{ kicker }} travels at {{ speed }} m/s at {{ time }}s",
  "builder.warning.pass.extreme.height":
    "{{ name }}'s pass at {{ time }}s has an extreme height of {{ height }}m",
  "builder.warning.pass.extreme.time":
    "{{ name }}'s pass at {{ time }}s has an extreme flight time of {{ flightTime }}s",

  // Builder toolbar
  "builder.selected": "Selected:",
  "builder.selected.none": "None",
  "builder.time": "Time:",
  "builder.recovery.title": "Recover unsaved scenario?",
  "builder.recovery.message": "A local recovery draft from {{ savedAt }} was found for this scenario. Restore it to recover unsaved work, or discard it to keep the loaded version.",
  "builder.recovery.restore": "Restore draft",
  "builder.recovery.discard": "Discard draft",

  // Builder menu
  "builder.menu.save": "Save",
  "builder.menu.save.as": "Save As",
  "builder.menu.play.test": "Play Test",
  "builder.menu.import.file": "Import File",
  "builder.menu.export.file": "Export File",
  "builder.menu.exit": "Exit Builder",
  "builder.menu.settings": "Settings",
  "builder.menu.view.rotation": "View Rotation:",
  "builder.menu.play.speed": "Play Speed:",
  "builder.menu.play.resolution": "Play Resolution:",
  "builder.menu.player.speed.limit": "Player Speed Limit:",
  "builder.menu.ball.speed.limit": "Ball Speed Limit:",
  "builder.menu.show.waypoints": "Show Waypoints",
  "builder.menu.show.actions": "Show Actions",
  "builder.menu.show.ball.path": "Show Ball Path",
  "builder.menu.show.jersey.numbers": "Show Jersey Numbers",
  "builder.menu.route.fade.distance": "Route Fade Distance:",
  "builder.menu.untitled": "Untitled",
  "builder.menu.exit.confirm.title": "Are you sure?",
  "builder.menu.exit.confirm.message": "You have unsaved changes. Are you sure you want to exit?",
  "builder.menu.save.success.title": "Scenario saved",
  "builder.menu.save.success.message": "Your scenario changes have been saved.",
  "builder.menu.save.error.title": "Error saving scenario",
  "builder.menu.save.error.message": "Failed to save your scenario changes.",

  // Decision overlay
  "builder.decision.toggle.show": "Show Scores",
  "builder.decision.toggle.hide": "Hide Scores",
  "builder.decision.auto.timeline.score": "Auto Timeline Score",
  "builder.decision.option": "Option #{{ index }}",
  "builder.decision.metric.completion": "Completion",
  "builder.decision.metric.threat": "Threat",
  "builder.decision.metric.goal.chance": "Goal chance",
  "builder.decision.metric.turnover": "Turnover",
  "builder.decision.autoassign.error.noScenario": "No valid scenario is available for auto timeline score.",
  "builder.decision.autoassign.error.noUserPlayer": "Add a user-controlled player before running auto timeline score.",
  "builder.decision.autoassign.error.noTimelineData": "Decision engine returned no usable timeline data.",
  "builder.decision.autoassign.error.noScoreWindows": "No usable timeline score windows were returned, so no score actions were applied.",
  "builder.decision.autoassign.error.generic": "Auto timeline score failed. Please try again.",
  "builder.decision.autoassign.success":
    "Applied {{ created }} score windows across {{ players }} players.{{ replacedText }}{{ defaultedText }}",
  "builder.decision.autoassign.success.replaced": " Replaced {{ count }} existing score actions.",
  "builder.decision.autoassign.success.defaulted": " Defaulted to 0: {{ players }}{{ more }}.",
  "builder.decision.autoassign.success.defaulted.more": " +{{ count }} more",

  // Action menu
  "builder.action.deselect": "Deselect",
  "builder.action.delete": "Delete",
  "builder.action.set.height": "Set Height",
  "builder.action.set.score": "Set Score",
  "builder.action.set.time": "Set Time",
  "builder.action.more": "More",

  // Player menu
  "builder.player.take.ball": "Take Ball",
  "builder.player.pass.ball": "Pass Ball",
  "builder.player.shoot.ball": "Shoot Ball",
  "builder.player.set.player": "Set Player",
  "builder.player.look": "Look",
  "builder.player.face": "Face",
  "builder.player.face.forward": "Face forward",
  "builder.player.face.target": "Face target",
  "builder.player.signal": "Signal",
  "builder.player.score": "Score",
  "builder.player.set.position": "Set Position",
  "builder.player.set.as": "Set as {{ initials }}",

  // Field menu
  "builder.field.flip.teams": "Flip Teams",
  "builder.field.add.opponent": "Add Opponent",
  "builder.field.add.team.mate": "Add Team Mate",
  "builder.field.opponent": "Opponent {{ initials }}",
  "builder.field.team.mate": "Team Mate {{ initials }}",
  "builder.field.close": "Close",

  // Waypoint menu
  "builder.waypoint.insert.after": "Insert After",
  "builder.waypoint.insert.before": "Insert Before",
};
